import script from "./InscriptionView.vue?vue&type=script&setup=true&lang=js"
export * from "./InscriptionView.vue?vue&type=script&setup=true&lang=js"

import "./InscriptionView.vue?vue&type=style&index=0&id=1cfadb09&lang=css"

const __exports__ = script;

export default __exports__